export default {
  title: 'Développeurs',
  subtitle: "Clés API, webhooks et historique des livraisons pour votre intégration à l'API Partenaire.",
  no_account: "Aucun compte API Partenaire pour l'instant — contactez Foodamigos pour en obtenir un.",
  no_account_manage: "Aucun compte API Partenaire pour l'instant — créez-en un pour commencer à émettre des clés.",
  buttons: {
    new_account: 'Nouveau compte',
    edit_account: 'Modifier le compte',
    docs: "Documentation de l'API",
  },
  tabs: {
    api_keys: 'Clés API',
    webhooks: 'Webhooks',
    deliveries: 'Livraisons',
  },
  toasts: {
    load_error: 'Impossible de charger vos comptes API Partenaire.',
  },
};
